import { render, staticRenderFns } from "./DataItemInfoOpeningHoursItem.vue?vue&type=template&id=4bec7179&scoped=true&"
import script from "./DataItemInfoOpeningHoursItem.vue?vue&type=script&lang=js&"
export * from "./DataItemInfoOpeningHoursItem.vue?vue&type=script&lang=js&"
import style0 from "./DataItemInfoOpeningHoursItem.vue?vue&type=style&index=0&id=4bec7179&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bec7179",
  null
  
)

export default component.exports